import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  styled,
  Typography,
} from '@mui/material';
import { ComponentProps } from 'react';

export const StyledWrapper = styled(Stack)({
  width: '100%',
  minHeight: '100%',
  justifyContent: 'start',
  alignItems: 'center',
  backgroundColor: '#ebeef5',
});

export const StyledInner = styled(Stack)(({ theme }) => ({
  width: '100%',
  maxWidth: theme.spacing(144),
  padding: theme.spacing(3),
  gap: theme.spacing(5),
  justifyContent: 'start',
  alignItems: 'center',
  boxSizing: 'border-box',
}));

const StyledHeaderBase = styled(Typography)(({ theme }) => ({
  fontSize: theme.spacing(7.5),
  fontFamily: '"Inter", sans-serif',
  fontOpticalSizing: 'auto',
  fontStyle: 'normal',
  textAlign: 'center',
  letterSpacing: '-0.025em',
  lineHeight: 1,
  fontWeight: 800,
}));

export const StyledHeader = (
  props: ComponentProps<typeof StyledHeaderBase>
) => <StyledHeaderBase variant="h1" {...props} />;

export const StyledDescription = styled(Typography)(({ theme }) => ({
  fontSize: theme.spacing(2.5),
  fontFamily: '"Inter", sans-serif',
  textAlign: 'center',
  lineHeight: 1.75,
  color: '#6b7280',
  maxWidth: theme.spacing(72),
}));

export const StyledSliderWrapper = styled(Card)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.spacing(2),
  maxWidth: theme.spacing(84),
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1),
}));
export const StyledSliderHeader = styled(CardHeader)(({ theme }) => ({
  padding: 0,
  '.MuiTypography-root': {
    fontFamily: '"Inter", sans-serif',
    fontWeight: 700,
    lineHeight: 1.75,
    fontSize: theme.spacing(2),
  },
}));

export const StyledSliderContent = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  width: '100%',
  alignItems: 'center',
  padding: 0,
  '&:last-child': {
    paddingBottom: 0,
  },
}));

export const StyledSliderQuantityWrapper = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(0.5),
}));

export const StyledSliderQuantity = styled(Typography)(() => ({
  fontFamily: '"Inter", sans-serif',
  fontWeight: 700,
  color: '#6d77c8',
}));

export const StyledSliderQuantityText = styled(Typography)(() => ({
  fontFamily: '"Inter", sans-serif',
  color: '#6b7280',
}));

export const StyledPriceBoxesWrapper = styled(Stack)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
  gap: theme.spacing(4),
  '> *': {
    flex: 1,
  },
}));

export const StyledPublishInfoCard = styled(Card)(() => ({}));

export const StyledPublishInfoCardHeader = styled(CardHeader)(() => ({}));

export const StyledPublishInfoCardContent = styled(CardContent)(() => ({}));
